let GlobalInputTextType = {
    NodeInput: 1,
    EncircleLine: 2,
    NodeConnectLine: 3,
    NodeExplain: 4,
    NodeTitleInput: 5,
}
export default GlobalInputTextType